import { context } from '@adornis/baseql/server/context.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import type { AdornisMailer } from '@adornis/mails/server/mailer.js';

export const mailer = (async (): Promise<AdornisMailer> => {
  // @ts-expect-error will only be used on server so this is fine
  if (!context?.serverContext) return;

  const { config: mailsConfig } = await import('@adornis/mails/config.js');
  const { AdornisMailer } = await import('@adornis/mails/server/mailer.js');

  const isMailpit = mailsConfig.get('SMTP_HOST').startsWith('mailpit');

  const testingConfig = isMailpit
    ? {}
    : {
        emailWhiteList: [
          // uni frankfurt
          'lill@pharmchem.uni-frankfurt.de',
          'catapano@chemie.uni-frankfurt.de',
          'lill@uni-frankfurt.de',
          'schulze-vorberg@psych.uni-frankfurt.de',
          'j.blank@em.uni-frankfurt.de',
          'j.blank@sli.uni-frankfurt.de',
          'schmitt@studiumdigitale.uni-frankfurt.de',
          'diehl@biochem.uni-frankfurt.de',
          'schneider-gladbach@em.uni-frankfurt.de',
          'weiss@studiumdigitale.uni-frankfurt.de',
          'heckmann@paed.psych.uni-frankfurt.de',
          'hansen@paed.psych.uni-frankfurt.de',
          'Claudia.Walker@psych.uni-frankfurt.de',
          'feldmann@psych.uni-frankfurt.de',
          'N.Maier@psych.uni-frankfurt.de',
          'gross@psych.uni-frankfurt.de',
          'fabriz@psych.uni-frankfurt.de',
          'machura@psych.uni-frankfurt.de',
          'mendzheritskaya@psych.uni-frankfurt.de',
          'kekelidze@psych.uni-frankfurt.de',
          'schur@sli.uni-frankfurt.de',
          'Boryszewska@em.uni-frankfurt.de',
          'ghasemizadeh@studiumdigitale.uni-frankfurt.de',
          'gutermann@sli.uni-frankfurt.de',
          'attenberger@sli.uni-frankfurt.de',
          'pomper@sli.uni-frankfurt.de',
          'jobboerse@jungchemiker.de',
          'schneiders@sli.uni-frankfurt.de',
          'dorotheeschneiders@gmail.com',
          'j.werner@sli.uni-frankfurt.de',
          'mentoring@uni-frankfurt.de',
          'jownsi@hotmail.com',
          'jbjochim@gmail.com',
          'n.pritschkat@ub.uni-frankfurt.de',
          'a.weber@ub.uni-frankfurt.de',
          't.wack@jur.uni-frankfurt.de',
          'koenig@sli.uni-frankfurt.de',
          'veith@studiumdigitale.uni-frankfurt.de',
          // ICS-RM
          'julia.jochim@tu-darmstadt.de',
          'jbjochim@gmail.com',
          'adornis.test@gmx.de',
        ],
        domainWhiteList: ['adornis.de'],
      };

  const mailerInstance = AdornisMailer.getInstance(
    {
      production: {},
      development: isMailpit
        ? {}
        : {
            emailWhiteList: [],
            domainWhiteList: [
              'adornis.de',
              'uni-frankfurt.de',
              'sd.uni-frankfurt.de',
              'med.uni-frankfurt.de',
              'psych.uni-frankfurt.de',
              'hdm-stuttgart.de',
            ],
          },
      staging: testingConfig,
      qa: testingConfig,
    }[baseConfig.get('DEPLOYMENT')] ?? testingConfig,
  );

  // remove whitelists if we're using mailpit as smtp host, because this will not actually send mails
  if (isMailpit) {
    mailerInstance.domainWhitelist = undefined;
    mailerInstance.emailWhitelist = undefined;
  }

  return mailerInstance;
})();
